import { useState, useRef, useEffect } from "react";
import { useRaspStore } from "../store/raspStore.ts";
import { programmepreferenceService } from "../services/ProgrammepreferenceService";
// getUserIdFromJWT removed, using context in components

export const useProgrammepreferenceViewModel = (userId: string, appId: string) => {
  const [fields, setFields] = useState<any[]>([]);
  const [foreignKeyData, setForeignKeyData] = useState<any>({});
  const [enums, setEnums] = useState<any>({});
  const [dataToSave, setDataToSave] = useState<any>({});
  const [fetchedForeign, setFetchedForeign] = useState<Set<string>>(new Set());
  const [fetchedEnum, setFetchedEnum] = useState<Set<string>>(new Set());
  const addSubmission = useRaspStore((s) => s.addSubmission);
  const getSubmissions = useRaspStore((s) => s.getSubmissions);
  const getUserAllData = useRaspStore((s) => s.getUserAllData);
  useEffect(() => {
    const dataFromStore = getSubmissions(userId, "Programmepreference");
    const allData = getUserAllData(userId);
    console.log("all data from store for student resource", dataFromStore, allData);
  }, [])
  const loadMetadata = async () => {
    const metadata = await programmepreferenceService.getMetadata();
    const metaFields = metadata[0].fieldValues || [];

    setFields(metaFields);
    // FOREIGNS
    for (let field of metaFields) {
      if (field.foreign) {
        const foreignName = field.foreign;

        if (!fetchedForeign.has(foreignName)) {
          const updated = new Set(fetchedForeign);
          updated.add(foreignName);
          setFetchedForeign(updated);

          const data = await programmepreferenceService.getForeignResource(foreignName);

          setForeignKeyData((prev: any) => ({
            ...prev,
            [foreignName]: data,
          }));
        }
      }
    }

    // ENUMS
    for (let field of metaFields) {
      if (field.isEnum) {
        const enumName = field.possible_value;

        if (!fetchedEnum.has(enumName)) {
          const updatedEnum = new Set(fetchedEnum);
          updatedEnum.add(enumName);
          setFetchedEnum(updatedEnum);

          const values = await programmepreferenceService.getEnum(enumName);

          setEnums((prev: any) => ({
            ...prev,
            [enumName]: values,
          }));
        }
      }
    }
  };

  const save = async (extraData: any = {}) => {
    const params = new FormData();

    const payloadToSave = { ...dataToSave, ...extraData };

    // 🧠 CLEAN inactive preferences
    const cleanPref = (prefKey: string) => {
      const fields = ["rank", "rollno", "score", "scorecard", "subjects", "year"];

      fields.forEach((field) => {
        payloadToSave[`${prefKey}${field}`] = null;
      });

      payloadToSave[prefKey] = null;
    };
    if (!payloadToSave.pref1) cleanPref("pref1");
    if (!payloadToSave.pref2) cleanPref("pref2");
    if (!payloadToSave.pref3) cleanPref("pref3");
    if (!payloadToSave.pref4) cleanPref("pref4");
    if (!payloadToSave.pref5) cleanPref("pref5");

    const selectedFileKeys = Object.keys(payloadToSave).filter((key) => payloadToSave[key] instanceof File);
    if (selectedFileKeys.length > 0) {

      selectedFileKeys.forEach((key) => {
        params.append(key, payloadToSave[key]);

        // clear file from JSON payload
        payloadToSave[key] = "";
      });

      params.append("description", "application-gate");
      params.append("appId", "admission-portal");
      params.append("dmsRole", "admin");
      params.append("user_id", userId);
      params.append("tags", "t1,t2,attend,gate");
    }

    const jsonString = JSON.stringify(payloadToSave);
    const base64Encoded = btoa(
      encodeURIComponent(jsonString).replace(/%([0-9A-F]{2})/g, (_, p1) =>
        String.fromCharCode(parseInt(p1, 16))
      )
    )

    // if (payloadToSave.id) {
    //   params.append('action', 'MODIFY');
    // }

    params.append('resource', base64Encoded);

    const response = await programmepreferenceService.create({
      params,
    });

    if (response.errCode !== -1) {
      addSubmission(userId, "Student", dataToSave);
      console.log("data initialized in store in create form model", getUserAllData(userId))
    }
  };

  return {
    fields,
    setFields,
    enums,
    foreignKeyData,
    setForeignKeyData,
    setEnums,
    dataToSave,
    setDataToSave,
    loadMetadata,
    save,
  };
};
